import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        notification_types: {data: [], current_page: 1, total: 0, per_page: 10},
        loading: false,
        errors: {
            data: {
                errors: {
                    name: [],
                    category: [],
                    color: []
                }
            }
        },
        has_errors: false,
        dialogVisible: false,
    },
    getters: {
        loading: state => state.loading,
        dialogVisible: state => state.dialogVisible,
        notification_types: state => state.notification_types,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
    },
    mutations: {
        setLoading(state, val) {
            state.loading = val
        },
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        setNotificationTypes(state, data) {
            state.notification_types = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            name: [],
                            category: [],
                            color: []
                        }
                    }
                };
            }
        }
    },
    actions: {
        async openDialogVisible({commit}, status) {
            commit('setDialogVisible', status);
        },

        async getNotificationTypes({commit}, filters) {
            try {
                commit('setLoading', false);
                const response = await api.getNotificationTypes(filters);
                commit('setNotificationTypes', response);
                commit('setLoading', false);
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
        async createNotificationType({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.createNotificationType(data);
                dispatch('getNotificationTypes', {
                    paginate: true
                })
                ElMessage.success('Notification Type created successfully!');
                commit('setLoading', false)
                commit('setDialogVisible', false)
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },
        async editNotificationType({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.editNotificationType(data);
                dispatch('getNotificationTypes', {
                    paginate: true
                });
                ElMessage.success('Information updated successfully.');
                commit('setLoading', false)
                commit('setDialogVisible', false)
            } catch (e) {
                commit('setLoading', false);
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },

        async deleteNotificationType({dispatch}, data) {
            try {
                const response = await api.deleteNotificationType(data);
                dispatch('getNotificationTypes', {
                    paginate: true
                })
                ElMessage.success({
                    message: response.message,
                    duration: 10000
                });
            } catch (e) {
                if (e.response.status === 422) {
                    ElMessage.error(e.response.data.message)
                } else {
                    ElMessage.error('Error deleting Notification Type');
                }
            }
        }
    }
}
